import apiClient from 'clients/apiClient';
import config from 'helpers/config';
import * as types from 'store/actions/types';
import { put, takeEvery } from 'redux-saga/effects';
import { showNotification } from 'store/actions/uiActions';
import * as fetchProductOccupancy from 'store/actions/products/occupancy/fetchProductOccupancy';

function* fetchProductOccupancyAsync({ payload }) {
    const {
        id,
        params,
    } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/products/${ id }/occupancy`;

        const response = yield apiClient.read(url, params);

        yield put(fetchProductOccupancy.fetchProductOccupancySuccess(payload, response));
    } catch (error) {
        yield put(fetchProductOccupancy.fetchProductOccupancyFailure(error));
    }
}

function* failureMessage({ error }) {
    const { message } = error.response;

    if (!message) {
        return;
    }

    yield put(showNotification(message, 'warning'));
}

export default function* productOccupancySagas() {
    yield [
        takeEvery(types.FETCH_PRODUCT_OCCUPANCY, fetchProductOccupancyAsync),
        takeEvery(types.FETCH_PRODUCT_OCCUPANCY_FAILURE, failureMessage),
    ];
}


// WEBPACK FOOTER //
// ./src/store/sagas/product/productOccupancySagas.js